/**
 * @file 组件入口
 * @author eric
 * @date 2020-04-02
 */

import Skeleton from './Skeleton.vue';

export default {
  install: function(_vue) {
    const SkeletonConstructor = _vue.extend(Skeleton);
    let instance;

    const createElement = () => {
      return new SkeletonConstructor({
        el: document.createElement('div'),
      });
    };

    _vue.prototype.$coolSkeleton = {
      show() {
        if (!instance) {
          instance = createElement();
          // 添加到页面
          document.body.appendChild(instance.$el);
        }
        instance.fixCenter = true;
        instance.show = true;
      },
      hide() {
        if (instance) {
          instance.show = false;
        }
      }
    };
  }
};
